/*
adityaa 09/27/2022 2700799562 Save alert added
adityaa 09/27/2022 2700799562 Implemented save alert for Global Fields module
Ravi 10/04/2022 2700799562 UI/GlobalListGroup/DialogBox
Ravi 10/04/2022 2700799562 GlobalFieldList
ashraf 10/04/2022 2700799562 fixed payload changes for global field, group, fieldlist Api's, alert popup changes
sohel 10/06/2022 2700799562 Global Field List ->Fixed GAL - 423 , 426
ashraf 10/18/2022 2700799562 global field, group, field list UI changes
Suresh Peddavoora 11/18/2022 2700799562 Fixed Alignments for Dialog Box Text
Lalitha  11/28/2022 2700799562 Added title and content in Dialog Box
Rohini  12/05/2022 2700799562 Added title and content in Dialog Box
Raghu 03/01/2023 2700799562 fixed buttons
*/

import React, {useContext} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import SelectTabContextProvider from '../../components/SelectTabContext/SelectTabContext';
import reusableInputStyles from '../../components/InputStyles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {Divider} from '@material-ui/core';
function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}
export default function SaveAlert({
  setTabValue,
  setOpen,
  open,
  tabvalue,
  value,
  title = 'Unsaved changes',
}) {
  const {newTabValue} = useContext(SelectTabContextProvider);
  const handleClose = () => {
    setOpen(false);
  };
  const classes = reusableInputStyles();
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle id="draggable-dialog-title" className="alert-popup">
          <div className="dialogue-alert-title">
            <Typography variant="h4">
              {title}
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <Divider />
        <div className={classes.dialoguecardStyles}>
          <div className="text-center my-3">
            {value ? (
              <Typography variant="h4">{value}</Typography>
            ) : (
              <Typography variant="h4">
                This page contains unsaved changes. Do you still wish to leave this page?
              </Typography>
            )}
          </div>
          <div className="button-table-spacing-mb new-standard-textfields">
            <>
              <Button
                onClick={() => {
                  setTabValue(tabvalue);
                  setOpen(false);
                }}
                type="button"
                // changed buttons variants to oulined
                variant="outlined"
                className={`mx-1 search-btn`}
              >
                No
              </Button>
              <Button
                type="submit"
                variant="outlined"
                className={`mx-1 reset-btn`}
                onClick={() => {
                  setTabValue(newTabValue);
                  setOpen(false);
                }}
              >
                Yes
              </Button>
            </>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
